export enum PdfPermission {
	AllowPrinting = 1,
	AllowChangeDocument = 2,
	AllowDocumentAssembly = 3,
	AllowContentCopying = 4
}